import React from 'react';
import PropTypes from 'prop-types';

import { LocaleService } from '@sm360/widget-commons-core-services';

import 'login/components/Transaction/TimeSavedBlock/TimeSavedBlock.scss';

const TimeSavedBlock = ({ timeSaved }) => {
    function secondsToHms(d) {
        const timeInSecondes = Number(d);
        const timeInMinutes = Math.floor((timeInSecondes % 3600) / 60);
        return `${timeInMinutes} min.`;
    }
    return (
        <div className="TimeSavedBlock--wrapper has-success-background">
            <icon className="icon-stopwatch" />
            <span>{LocaleService.t('TRANSACTION_PROGRESSION.TIME_SAVED_BLOCK.SAVE')}</span>
            <span>{secondsToHms(timeSaved)}</span>
            <span>{LocaleService.t('TRANSACTION_PROGRESSION.TIME_SAVED_BLOCK.DEALERSHIP')}</span>
        </div>
    );
};

TimeSavedBlock.propTypes = {
    timeSaved: PropTypes.number,
};

TimeSavedBlock.defaultProps = {
    timeSaved: 0,
};

TimeSavedBlock.displayName = 'TimeSavedBlock';

export default TimeSavedBlock;



// WEBPACK FOOTER //
// ./src/components/Transaction/TimeSavedBlock/TimeSavedBlock.jsx